import { lazy } from 'react';

// ----------------------------------------------------------------------

const NomenclatureCatalogPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "NomenclatureCatalogPage" */
      '@/pages/nomenclature/catalog/NomenclatureCatalogPage'
    ),
);

export default NomenclatureCatalogPage;
